import classes from "../index.module.scss";
import React, { useState, useEffect } from "react";
import { Table, Form, Dropdown, Button, Row, Col } from "react-bootstrap";
import { ENDPOINT, KEY } from "config/constants";
import AuthService from "services/auth.service";
import accessHeader from "services/headers/access-header";
import swal from "sweetalert";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Accordion from "react-bootstrap/Accordion";
import AddFaqPopup from "./AddFaqPopup";
import Swal from "sweetalert2/dist/sweetalert2.js";
import "sweetalert2/src/sweetalert2.scss";

const Faqs = () => {
  const Swal = require("sweetalert2");

  const [formData, setFormData] = useState({});
  const [isLoader, setIsLoader] = useState(false);
  const [modalShow, setModalShow] = useState(false);

  const handleChange = (event) => {
    let name = event.target.name;
    let value = event.target.value;
    // const value = event.target.value.replace(/\D/g, "");
    // const value = event.target.value.replace(/(0|)\D/g, "");
    setFormData((prevalue) => {
      return {
        ...prevalue, // Spread Operator
        [name]: value,
      };
    });
  };

  const handleEditClick = (ind) => {
    // set edit mode for the corresponding FAQ
    const updatedFormData = [...formData];
    updatedFormData[ind].editMode = true;
    setFormData(updatedFormData);
  };

  const handleInputChange = (index, value, field) => {
    const updatedData = [...formData];
    updatedData[index][field] = value;
    setFormData(updatedData);
  };

  const handleSaveClick = async (id) => {
    // id.preventDefault();
    try {
      const res = await AuthService.patchMethod(
        `${ENDPOINT.admin_guidelines.update_faq}${id}`,
        true,
        formData
      );
      if (res) {
        toast.success("FAQ updated successfully", {
          position: "bottom-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "dark",
        });
      }
      guidlinessWaiverData();
      console.log(res);
    } catch (err) {
      swal("Error", `${AuthService.errorMessageHandler(err)}`, "error");
    }
  };

  const guidlinessWaiverData = async () => {
    await AuthService.getMethod(
      `${ENDPOINT.admin_guidelines.faq_listing}`,
      true
    )
      .then((res) => {
        setFormData(res.data.faq);
        setIsLoader(true);
        console.log("faq", res.data.faq);
      })
      .catch((err) => {
        swal("Error", `${AuthService.errorMessageHandler(err)}`, "error");
      });
  };

  const deleteFaq = async (id) => {
    try {
      Swal.fire({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, delete it!",
      }).then(async (result) => {
        if (result.isConfirmed) {
          const deleteRes = await AuthService.deleteMethod(
            `${ENDPOINT.admin_guidelines.delete_faq}${id}`,
            true
          );
          if (deleteRes) {
            Swal.fire(
              "Deleted!",
              "Your file has been deleted.",
              "success"
            ).then(() => {
              guidlinessWaiverData();
            });
          }
        }
        // else if (result.dismiss === Swal.DismissReason.cancel) {
        //   // Handle Cancel button click
        //   Swal.fire(
        //     'Cancelled',
        //     'Your file is safe :)',
        //     'error'
        //   );
        // }
      });
    } catch (err) {
      swal("Error", `${AuthService.errorMessageHandler(err)}`, "error");
    }
  };

  useEffect(() => {
    guidlinessWaiverData();
  }, []);

  // convert date format to month / day / year
  function formatDate(date) {
    var d = new Date(date),
      month = "" + (d.getMonth() + 1),
      day = "" + d.getDate(),
      year = d.getFullYear();

    if (month.length < 2) month = "0" + month;
    if (day.length < 2) day = "0" + day;

    return [month, day, year].join("/");
  }

  if (!isLoader) {
    return (
      <div className="loader">
        <h3>Loading...</h3>
      </div>
    );
  }

  const date = formData.updatedDate ? new Date(formData.updatedDate) : null;
  const options = {
    year: "numeric",
    month: "long",
    day: "numeric",
  };
  const formattedDate = new Intl.DateTimeFormat("en-US", options).format(date);

  return (
    <>
      <Row>
        <Col md={8}>
          <div className={classes.editSection}>
            <Form>
              <Form.Group className={`${classes.formGroup} mb-3`}>
                <Accordion defaultActiveKey="0">
                  {formData?.map((content, ind) => {
                    return (
                      <Accordion.Item key={ind} eventKey={ind + 1}>
                        {content.editMode ? null : (
                          <Accordion.Header>
                            {content.question}
                          </Accordion.Header>
                        )}
                        <Accordion.Body>
                          {content.editMode ? (
                            <>
                              <input
                                type="text"
                                value={
                                  content.editMode
                                    ? formData[ind].question
                                    : content.question
                                }
                                onChange={(e) =>
                                  handleInputChange(
                                    ind,
                                    e.target.value,
                                    "question"
                                  )
                                }
                              />
                              <input
                                className="my-2"
                                type="text"
                                value={
                                  content.editMode
                                    ? formData[ind].description
                                    : content.description
                                }
                                onChange={(e) =>
                                  handleInputChange(
                                    ind,
                                    e.target.value,
                                    "description"
                                  )
                                }
                              />
                              <button
                                type="button"
                                className={`${classes.editButton} my-2 `}
                                onClick={() => handleSaveClick(content.id)}
                              >
                                Save
                              </button>
                            </>
                          ) : (
                            <>
                              <p>{content.description}</p>
                              <div className="my-2">
                                <button
                                  type="button"
                                  className={`${classes.editButton} `}
                                  onClick={() => handleEditClick(ind)}
                                >
                                  Edit FAQ
                                </button>
                                <button
                                  type="button"
                                  className={`${classes.deleteButton} mx-2 `}
                                  onClick={() => deleteFaq(content.id)}
                                >
                                  Delete
                                </button>
                              </div>
                            </>
                          )}
                        </Accordion.Body>
                      </Accordion.Item>
                    );
                  })}
                  <button
                    type="button"
                    className="btn btn-light addMoreFaq my-3"
                    onClick={() => setModalShow(true)}
                  >
                    Add More
                  </button>
                </Accordion>
              </Form.Group>
            </Form>
          </div>
        </Col>
        <Col md={4}>
          {formData.map((content, indx) => {
            return (
              <>
                <div className={classes.logBox}>
                  <h4> {formattedDate} </h4>
                  <div className={"text-muted font-12"}>Update Logs</div>
                  <ul className={classes.logList}>
                    <li>
                      <div className={classes.box}>
                        <time className={"d-block"}>
                          {formatDate(content.updatedDate)}
                        </time>
                        <div>Term &amp; Conditions - Updated!</div>
                      </div>
                    </li>
                    <li>
                      <div className={classes.box}>
                        <time className="d-block">
                          {formatDate(content.updatedDate)}
                        </time>
                        <div>FAQ</div>
                      </div>
                    </li>
                  </ul>
                </div>
              </>
            );
          })}
        </Col>
      </Row>

      <AddFaqPopup
        guidlinessWaiverData={guidlinessWaiverData}
        show={modalShow}
        onHide={() => setModalShow(false)}
      />
    </>
  );
};

export default Faqs;
